import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AUTH_PREFIX_PATH } from 'configs/AppConfig';

const SecureRoute = ({ auth, component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (auth) return <Component {...props} />;
        if (!auth)
          return (
            <Redirect
              to={{
                pathname: `${AUTH_PREFIX_PATH}/login`,
                state: { from: props.location },
              }}
            />
          );
      }}
    />
  );
};

export default SecureRoute;
